<template>
  <anchor-text-field
    :rules="rules"
    v-mask="mask"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>
  </anchor-text-field>
</template>

<script>
import rules from '../../../plugins/form-rules';

export default {
  name: 'AnchorPhoneField',
  data: () => ({
    mask: '###-##-####',
  }),
  computed: {
    rules: vm => {
      const defaultRules = [
        rules.optional(rules.ssn),
      ];
      return vm.$attrs.rules ? vm.$attrs.rules.concat(defaultRules) : defaultRules;
    },
  },
};
</script>
